<template>
  <a-layout-header style="background: #fff; padding: 0;line-height: 64px;vertical-align: middle;">
    <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="setCollapsed(!collapsed)" />
    <div style="display: inline-block;float: right;margin-right: 20px;">
      <!-- <div style="height: 40px;display: inline-block;width:48px;height: 64px;">
        <a-badge :count="10" :offset="[6,0]">
          <a-icon type="bell" style="font-size: 16px;" />
        </a-badge>
      </div> -->
      <a-dropdown>
        <div style="height: 62px;margin-right: 20px;display: inline-block;">
          <a-avatar size="small">
            <a-icon type="user" height="24ps" width="24px"/>
            <!-- <img src="../../assets/avatar2.jpg" height="24ps" width="24px"/> -->
          </a-avatar>
          <span style="display: inline-block;margin-left: 5px;">{{userInfo.realName || '用户'}}</span>
        </div>
        <a-menu slot="overlay">
          <a-menu-item key="2" @click="changePassword">
            <a-icon type="edit" />
            修改密码
          </a-menu-item>
          <a-menu-item key="logout" @click="logout">
            <a-icon type="logout" />
            退出登录
          </a-menu-item>
          <!-- <a-menu-item key="2">账户设置</a-menu-item> -->
        </a-menu>
      </a-dropdown>
      <!-- <a-dropdown style="font-size: 16px;">
        <div style="height: 62px;display: inline-block;">
          <a-icon type="global"/>
        </div>
        <a-menu slot="overlay" @click="handleLanguageChange">
          <a-menu-item key="zh-CN">简体中文</a-menu-item>
          <a-menu-item key="en-US">英文</a-menu-item>
        </a-menu>
      </a-dropdown> -->
    </div>

    <!-- 修改密码弹窗 -->
    <EditPwd :show="showEditPasswordDialog" @closed="handleEditPasswordDialogCancel"></EditPwd>

  </a-layout-header>
</template>

<script>
  import editPwd from './editPwd.vue';
  import {
    mapGetters,
    mapMutations,
    mapActions
  } from 'vuex';
  import {
    logout
  } from '@/api/login.api';
  export default {
    props: {},
    components: {
      'EditPwd': editPwd
    },
    watch: {},
    data() {
      return {
        showEditPasswordDialog: false,
      }
    },
    computed: {
      ...mapGetters(["userInfo", "collapsed"]),
    },
    mounted() {
      let that = this;
    },
    methods: {
      ...mapActions([
        'setCollapsed'
      ]),
      handleEditPasswordDialogCancel(e){
        this.showEditPasswordDialog = false;
      },
      changePassword(e) {
        this.showEditPasswordDialog = true;
      },
      logout(e) {
        logout().then(res=>{
          console.log(res);
          window.location.reload();
        });
      }
    }
  }
</script>

<style scoped lang="less">
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color .3s;
  }

  .trigger:hover {
    color: #1890ff;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/sideHeader.vue